<script setup>
  import { computed, useSlots } from 'vue'
  import MapMenuSelect from '@/components/MapMenuSelect.vue';

  const props = defineProps({
    popUp: {
      type: String,
      required: false,
    }
  })

  const emit = defineEmits(['showSheet']);

  const slots = useSlots();

  const selectorClasses = computed(() => ([
    {
      'jwx-source-selector--info-popup': props.popUp && props.popUp === 'info', 
      'jwx-source-selector--model-run-popup': props.popUp && props.popUp === 'model-run', 
    }
  ]));

  const hasPopup = !!slots.popup;

</script>

<template>
  <div class="jwx-map__source-selector jwx-map-block jwx-map-block--transparent-border">
    <div class="jwx-map-block__content">
      <div 
        class="jwx-source-selector"
        :class="selectorClasses"
        :data-popup="hasPopup"
      >
        <MapMenuSelect
          @buttonClick="emit('showSheet')"
          class="jwx-source-selector__button"
          :data-divider="hasPopup"
        >
          <template #icon>
            <slot name="icon"></slot>
          </template>
          <template #label>
            <slot name="label"></slot>
          </template>
        </MapMenuSelect>      
        <slot name="popup"></slot>
      </div>
    </div>
  </div>
</template>